'use client'
import { useState, useEffect, Suspense } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import MenuButton from '@/components/atoms/buttons/MenuButton'
import MenuLinkButton from '@/components/atoms/buttons/MenuLinkButton'
import SearchForm from '@/components/molecules/SearchForm'
import styles from './style.module.scss'

export const Menu = () => {
  const [isMenuOpen, setIsOpen] = useState(false)
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const handleClick = () => {
    setIsOpen(!isMenuOpen)
  }
  useEffect(() => {
    if (isMenuOpen) {
      setIsOpen(!isMenuOpen)
    }
  }, [pathname, searchParams])
  return (
    <nav>
      <MenuButton isMenuOpen={isMenuOpen} handleClick={handleClick} />
      <div
        className={styles.container + ' ' + (isMenuOpen ? styles.openMenu : '')}
      >
        <div className={styles.menuContainer}>
          <div className={styles.inner}>
            <div className={styles.menuCard}>
              <h2 className={styles.title}>MENU</h2>
              <div className={styles.links}>
                <MenuLinkButton title="Top" />
                <MenuLinkButton path={'/category'} title="Category" />
                <MenuLinkButton path={'/tag'} title="Tag" />
                <MenuLinkButton path={'/post/notes/about'} title="About" />
              </div>

              <div className={styles.divider} aria-hidden="true" />

              <section
                className={styles.searchSection}
                aria-labelledby="menu-search"
              >
                <h3 id="menu-search">さがす</h3>
                <Suspense>
                  <SearchForm />
                </Suspense>
              </section>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Menu
